import { Outlet } from 'react-router-dom'
import { AppShell } from '@/shared/components/AppShell/AppShell'

/** `AppShell` already renders `<main sx={{ p: 3, … }}>` — avoid a nested duplicate `main` + padding stack. */
export function MainLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
